import {Component, Input, OnInit} from '@angular/core';
import {ApiService} from '../../api.service';
import {AngularFireAuth} from '@angular/fire/auth';

@Component({
  selector: 'app-note-field',
  templateUrl: './note-field.component.html',
  styleUrls: ['./note-field.component.css']
})
export class NoteFieldComponent implements OnInit {
  @Input() testData;
  value;
  isEdit = false;
  idToken;

  constructor(private apiService: ApiService,
              private angularFireAuth: AngularFireAuth) { }

  ngOnInit(): void {
    this.value = this.testData.note;
    this.angularFireAuth.authState.subscribe(async user => {
      const token = await user.getIdTokenResult();
      this.idToken = token.token;
    });
  }

  submit() {
    this.isEdit = false;
    console.log(this.value);
    this.noteChange(this.value).then();
  }

  async noteChange(note: string) {
    const data = {
      note
    };
    await this.apiService.updateTestData(data, this.testData.calculationResult.testId, this.testData.uid, this.idToken);
  }

}
